export default __webpack_public_path__ + "static/media/authorization-sider-bg.78bb1934.png";